export default __webpack_public_path__ + "static/06.08-6717cbc4b6a2e5559a2829ac30f88999.png";